export type FacturaFiltro = 'DOCUMENTO' | 'ORDEN' | 'FACTURA';

export interface FacturaItem {
  ordenPedidoId?: number | string;
  numeroFactura?: string;
  documento?: string;
  descCodigo?: string;
  nombreCompleto?: string;
  nombre?: string;
  razonSocial?: string;
  nombreCliente?: string;
  nombreTitular?: string;
}

export interface ConsultarFacturaRequest {
  numeroFactura: string;
  ordenPedidoId: number | string;
  numeroIdentificacion: string | null;
  anio?: string;
}

const FACTURA_NUM_MAX_LEN = 30;
export const FACTURA_ANIO_MIN = 2011;

export function sanitizarNumeroFactura(raw: unknown): string {
  return String(raw ?? '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .slice(0, FACTURA_NUM_MAX_LEN)
    .toUpperCase();
}

export function requiereAnioFactura(facturaRaw: unknown): boolean {
  const factura = sanitizarNumeroFactura(facturaRaw);
  if (!factura) {
    return false;
  }
  if (factura.startsWith('FEV') || factura.startsWith('SETT')) {
    return false;
  }
  return !esPrefijoParcialFevOSett(factura);
}

function esPrefijoParcialFevOSett(valor: string): boolean {
  const v = valor.toUpperCase();
  return 'FEV'.startsWith(v) || 'SETT'.startsWith(v);
}

/** Normaliza `{ data: { response } }` o variantes del gateway descargaFactura. */
export function parseListadoFacturasResponse(res: unknown): FacturaItem[] {
  if (res == null) {
    return [];
  }
  if (Array.isArray(res)) {
    return res as FacturaItem[];
  }
  if (typeof res !== 'object') {
    return [];
  }
  const root = res as Record<string, unknown>;
  const data = root['data'];
  if (Array.isArray(data)) {
    return data as FacturaItem[];
  }
  if (data && typeof data === 'object') {
    const nested = (data as Record<string, unknown>)['response'];
    if (Array.isArray(nested)) {
      return nested as FacturaItem[];
    }
  }
  if (Array.isArray(root['response'])) {
    return root['response'] as FacturaItem[];
  }
  return [];
}

export function nombreDesdeFactura(item: FacturaItem | null | undefined): string {
  if (!item) {
    return '';
  }
  return String(
    item.nombreCompleto ||
      item.nombreTitular ||
      item.nombreCliente ||
      item.razonSocial ||
      item.nombre ||
      ''
  ).trim();
}

/** Nombre corto para saludo: primer nombre + primer apellido. */
export function armarNombreSaludo(nombreCompleto: unknown): string {
  const parts = String(nombreCompleto ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) {
    return '';
  }
  const toTitle = (value: string) =>
    value.toLowerCase().replace(/(^|\s)\S/g, (ch) => ch.toUpperCase());
  if (parts.length === 1) {
    return toTitle(parts[0]);
  }
  if (parts.length === 2) {
    return toTitle(`${parts[0]} ${parts[1]}`);
  }
  return toTitle(`${parts[0]} ${parts[parts.length - 2]}`);
}
